import { useEffect, useRef } from 'react';

/**
 * Scrolls a garage card into view when a deep link points at it
 * (?purchase= / ?inspection= / ?invoice= / ?inquiry=). The emails and in-app
 * notifications link there, so the member lands on the record the message was
 * about.
 *
 * Returns the ref to put on the card.
 */
const useFocusedCard = (focused) => {
    const ref = useRef(null);

    useEffect(() => {
        if (!focused) return undefined;
        // Wait a frame so a card that expands on focus has laid out first.
        const frame = window.requestAnimationFrame(() => {
            if (ref.current) ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return () => window.cancelAnimationFrame(frame);
    }, [focused]);

    return ref;
};

export default useFocusedCard;
